import { TreatmentPackages } from "../models";

export class ProfessionalPackagesService {

	/**
	 * Checks whether the treatment is running depending on the state of the packages
	 * @param packages
	 * @returns true, if packages have already been ordered
	 */
	public static isTreatmentRunning( packages: TreatmentPackages ) : boolean {
		if(!packages){
			return false;
		}
		return packages.next > 0;
	}

	/**
	 * Checks whehter all regular packages are already ordered by the customer
	 * @param packages
	 * @returns true, if next package would be a (chargeable) correction package
	 */
	public static areRegularPackagesConsumed( packages: TreatmentPackages) : boolean {
		if(!packages || !packages.steps || !Array.isArray(packages.steps) || packages.steps.length === 0){
			return false;
		}
		return packages.next >= packages.steps.length;
	}
}
